export default function emitGlobalFormEventWithData(action, data) {
    const ev = new CustomEvent('form-event-with-data', {
        detail: {
            action,
            data
        }
    });
    window.dispatchEvent(ev);
}
